import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEvent";

const useTrackEvent = <T extends TrackEventParameters<any, any>>(
    parameters: T,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.event, parameters, options);
};

export default useTrackEvent;
